import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { ObjectClassesSettingsType } from '@atlassian/jira-assets-data-manager-common/src/common/types.tsx';

const SETTING_TYPES: readonly ObjectClassesSettingsType[] = [
	'data-source-type',
	'data-source-priorities',
	'attribute-priorities',
	'default-cleansing-rules',
	'cleansing-categories',
] as const;

// TODO: Import and add entrypoints for each setting type when they are created
// const SETTINGS = {
// 	'data-source-type': dataSourceTypeEntryPoint,
// 	'data-source-priorities': dataSourcePrioritiesEntryPoint,
// 	'attribute-priorities': attributePrioritiesEntryPoint,
// 	'default-cleansing-rules': defaultCleansingRulesEntryPoint,
// 	'cleansing-categories': cleansingCategoriesEntryPoint,
// } as const;

const isValidSettingType = (settingType: unknown): settingType is ObjectClassesSettingsType => {
	if (typeof settingType !== 'string') {
		return false;
	}
	return SETTING_TYPES.some((validType) => validType === settingType);
};

export const assetsDataManagerObjectClassesSettingsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-assets-data-manager-object-classes-settings", jiraSpaEntry: "async-assets-data-manager-object-classes-settings" */ './src'
			),
	),
	getPreloadProps: ({
		context: {
			match: { params },
		},
	}: EntryPointRouteParams) => {
		const validSettingType = isValidSettingType(params?.settingType)
			? params.settingType
			: undefined;
		// TODO: When entrypoints are created for each setting type, uncomment SETTINGS object above
		// and update this to return:
		// return {
		// 	entryPoints: validSettingType
		// 		? {
		// 				[validSettingType]: {
		// 					entryPoint: SETTINGS[validSettingType],
		// 					entryPointParams: {},
		// 				},
		// 			}
		// 		: {},
		// 	extraProps: {},
		// };
		return {
			entryPoints: {},
			extraProps: {
				settingType: validSettingType,
			},
		};
	},
});
